'use strict';

class RcmFatForm {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.urlFields = this.fat.elForm.find('#fatv2-place');
        this.geoField = this.fat.elForm.find('#fatv2-location');
        this.geoPlaceField = this.fat.elForm.find('#fatv2-place');
        this.facetFields = this.fat.elForm.find('#fatv2-discipline');
        this.requiredFields = this.fat.elForm.find('#fatv2-discipline, #fatv2-location');
        this.submitButton = this.fat.elForm.find('[type="submit"]');
    }

    // Is form valid
    isFormValid() {
        // Required fields
        this.requiredFields.each(function () {
            $(this).trigger('change_custom');
        });

        // Geo field
        this.geoField.each(function () {
            $(this).trigger('change_custom');
        });

        return this.requiredFields.filter(function () { return $(this).parent().hasClass('Error') }).length == 0;
    }

    // Clear facet fields
    clearFacetFields() {
        this.facetFields.each(function () {
            // Select
            $(this).prop('selectedIndex', 0);
        });
    }
}
